module.exports = __webpack_public_path__ + "static/media/Colud-based-odr.a9a2f8f3.png";